export class ValidateUtils {
  static emailRegex = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
  static passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).+$/;
  static phoneRegex = /^s*-?[0-9]{6,11}s*$/;
  static noSpacesRegex = /^\S*$/;
  static bicCodeRegex = /^([a-zA-Z]){6}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/;
  static alphaNumericRegex = /[a-zA-Z0-9/-?:().,'+ ]+$/;

  static validatePhoneNumber = (value?: string) => {
    if (!value) return false;
    return new RegExp(this.phoneRegex).test(value);
  };

  static validateBicCodeField = (value?: string) => {
    if (!value) return false;
    const isValid = new RegExp(this.bicCodeRegex).test(value);
    return isValid;
  };
}
